<template>
  <waves></waves>
  <mapbox></mapbox>
</template>

<script>

import Waves from "@/components/Waves";
import Mapbox from "@/views/Mapbox";

export default {
  name: 'Home',
  components: {Mapbox, Waves},
}
</script>
